import { render, staticRenderFns } from "./PartDeleteButton.vue?vue&type=template&id=749c856c"
import script from "./PartDeleteButton.vue?vue&type=script&lang=ts"
export * from "./PartDeleteButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports